module.exports = __webpack_public_path__ + "static/media/lateraldirecciones.e7ee4552.svg";